import React, { Component } from 'react'
import { connect } from 'react-redux';

import classnames from "classnames";
import Button from './../shared/Button/index';

import styles from './../../styles/perfect_essay.styl';
import baseStyles from 'custom/base.styl';
import success from './../../img/success@3x.png';

import { profileUpdateStages } from "../../store/profile/actions";

class EssayResearchArgumentative extends Component {
  constructor(props) {
    super(props)

    this.state = {
      curStep: 'step1',
    }

    this.onStepClick = this.onStepClick.bind(this)
    this.onComplete = this.onComplete.bind(this)
    this.onStageNext = this.onStageNext.bind(this)
  }

  onStepClick(e) {
    const newStep = e.target.dataset.step;

    this.setState({
      curStep: newStep,
    });

    const el = document.getElementById(newStep);
    el.scrollIntoView({ behavior: "smooth" });

    // this.setState({
    //   curStep: newStep,
    // }, () => window.scrollTo({ top: offsetTop, behavior: 'smooth' }));
  }

  onComplete() {
    this.setState({
      curStep: 'finish',
    }, () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  onStageNext() {
    const { nextStage } = this.props;
    nextStage();
    return;
  }

  render() {
    const { curStep } = this.state;

    return (
      <div>
        {/* page-1 */}
        <div className={classnames(styles.perfect_essay)}>

          <div className={classnames(styles.comment_finish, { [styles.active]: curStep === 'finish' })}>
            <img src={success} alt="success" width="100px" />
            <h3>Thank you for completing <br /> the first essay</h3>
						<p>There’s only one test essay left <br /> before you join us as a writer and <br /> start working with real orders. <br /> Show there all your academic <br /> knowledge and writing skills, as we <br /> will check it thoroughly to decide <br /> whether you have passed the <br /> probation.</p>
            <Button onClick={(e) => this.onStageNext(e)} block >Begin the last essay</Button>
          </div>

          <div className={styles.catchword_left}>Running head: THE RELATIONSHIP OF LEADER BEHAVIOR THAT AFFECTS <br /> EMPLOYEE'S PERFORMANCE</div>
          <div className={styles.catchword}>0</div>

          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />

          <div className={classnames(styles.highlighting, styles.highlighting_type1, { [styles.active]: curStep === 'step1' })} data-step="step1" id="step1">

            <div className={styles.highlighting_content}>

              <div className={styles.center}>The relationship of leader behavior that affects employee's performance</div>
              <div className={styles.center}>Name of Student</div>
              <div className={styles.center}>Institution affiliation</div>

              <div className={classnames(styles.comment)}>
                <ul>
                  <li>The paper follows the requirements of the APA formatting style.</li>
                  <li>No personal information is included. </li>
                  <li>Please download a template to avoid mistakes and spend less time on formatting. </li>
                </ul>
                <div className={classnames(styles.btn_wrap, baseStyles.flex_right)}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step2">NEXT&rarr;&nbsp;</button>
                </div>
              </div>

            </div>
          </div>

        </div>

        {/* page-2 */}
        <div className={classnames(styles.perfect_essay)}>
          <div className={styles.catchword_left}>THE RELATIONSHIP BETWEEN LEADER BEHAVIOR AND EMPLOYEE'S <br /> PERFORMANCE</div>
          <div className={styles.catchword}>1</div>

          <p className={styles.center}>The relationship of leader behavior that affects employee's performance</p>

          <div className={classnames(styles.highlighting, styles.highlighting_type2, { [styles.active]: curStep === 'step2' })} data-step="step2" id="step2">
            <div className={styles.highlighting_content}>
              <p>The actions of the leaders are strongly connected to the productivity of their followers. Positive leader reward and ethical behavior increase employees’ performance by influencing their motivation, job-satisfaction, and commitment.</p>

              <div className={styles.comment}>
                <ul>
                  <li>The instructions are followed: the paper answers the required question whether “the relationship of leader behaviour affects employee's performance” or not explicitly. </li>
                  <li>Structure: The introduction contains brief background information and an arguable thesis statement.</li>
                  <li>The word count of the introduction is 10%.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step1">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step3">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>

          <div className={classnames(styles.highlighting, styles.highlighting_type3, { [styles.active]: curStep === 'step3' })} data-step="step3" id="step3">
            <div className={styles.highlighting_content}>
              <p>Reward behavior is vital in affecting the performance of employees, since it has a complex impact on employees and can be effectively utilized in motivating them to achieve a certain level of performance. As Walker, Johnson & Hoover (2013) suggest, “Leader reward behaviors are important determinants of employee attitudes, perceptions, and behaviors” (p. 647). It means that if a leader holds positive reward behavior, it would have a effect on employees, which in its turn would increase their productivity and quality of their work. The scholars assert that rewarding may be a very powerful tool in motivating high performers, helping them maintain the expected performance level, and encouraging them to work harder and “meet more difficult performance goals” (Walker et al., 2013, p. 647). Thus, positive reward behavior of leaders had a direct beneficial impact on employees’ productivity.</p>
              <div className={styles.comment}>
                <ul>
                  <li>Content: The paragraph is devoted to one idea that relates to the thesis and is supported with an example from the outside source.</li>
                  <li>Plagiarism: Direct quotations do not exceed 10% of the required word count. No unsupported claims are present in the paper.</li>
                  <li>Structure: The paragraph contains at least 3 sentences and does not exceed 200 words. It begins with a linking word that contributes to the logical flow of the essay.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step2">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step4">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>

          <div className={classnames(styles.highlighting, styles.highlighting_type4, { [styles.active]: curStep === 'step4' })} data-step="step4" id="step4">
            <div className={styles.highlighting_content}>
              <p>Leader ethical behavior is also effective in influencing employees’ performance since it is vital in commitment and satisfaction of the employees. Numerous studies confirm that various employees’ outcomes like citizenship behaviors, commitment, and job satisfaction are dependent on the ethical managerial behavior (Shin, Sung, Choi & Kim, 2015). It follows that ethical behavior of management plays an extremely important role in influencing the factors related to performance. Furthermore, the evidence from the empirical research proves that “top management ethical leadership enhances organizational performance” (Shin et al., 2015, p.44). Consequently, the positive leader ethical behavior can directly influence the productivity and quality of work of employees.</p>
              <div className={styles.comment}>
                <ul>
                  <li>Content: The task required to write an argumentative paper using a thesis that leader behavior influences employees’ performance. Each body paragraph supports the thesis and provides evidence to support it.</li>
                  <li>Word count of the body paragraphs comprise 80% (240 words).</li>
                  <li>Proofreading: No repetitions, misprints, punctuation issues are present in the paper.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step3">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step5">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>

          <div className={classnames(styles.highlighting, styles.highlighting_type1, { [styles.active]: curStep === 'step5' })} data-step="step5" id="step5">
            <div className={styles.highlighting_content}>
              <p>In conclusion, there is a link between leader behavior and employees’ performance, as ethical behavior of a leader advances the performance of employees influencing on their job-satisfaction, motivation, and commitment.</p>
              <div className={classnames(styles.comment, styles.comment_bottom)}>
                <ul>
                  <li>Content: The Conclusion contains no new information and restates the thesis. </li>
                  <li>Structure: The word count of the Conclusion is 10% of the required word count (1 page = 300 words). </li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step4">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step6">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>
        </div>


        {/* page-3 */}
        <div className={classnames(styles.perfect_essay)}>
        <div className={styles.catchword_left}>THE RELATIONSHIP BETWEEN LEADER BEHAVIOR AND EMPLOYEE'S <br /> PERFORMANCE</div>
          <div className={styles.catchword}>2</div>

          <div className={classnames(styles.highlighting, styles.highlighting_type3, { [styles.active]: curStep === 'step6' })} data-step="step6" id="step6">
            <div className={styles.highlighting_content}>
              <div className={styles.center}>References</div>

              <div>Jackson, E., Rossi, M., Rickamer Hoover, E., & Johnson, R. (2012). Relationships of leader </div>
              <p>reward behavior with employee behavior. <i>Leadership & Organization Development</i> </p>
              <p><i>Journal, 33</i>(7), 646-661. http://dx.doi.org/10.1108/01437731211265232.</p>

              <div>Shin, Y., Sung, S., Choi, J., & Kim, M. (2014). Top Management Ethical Leadership and Firm </div>
              <p>Performance: Mediating Role of Ethical and Procedural Justice Climate. <i>Journal Of</i> </p>
              <p><a href="Business Ethics, 129(1), 43-57. http://dx.doi.org/10.1007/s10551-014-2144-5."><i>Business Ethics, 129</i>(1), 43-57. http://dx.doi.org/10.1007/s10551-014-2144-5.</a></p>


              <div className={classnames(styles.comment)}>
                <ul>
                  <li>The minimum requirement to include 1 source per 1 page (300 words) is met.</li>
                  <li>The incorporated source is reliable, relevant (published within the last 5-7 years), and to the topic. The required article is incorporated.</li>
                  <li>Reference page is formatted according to the requirements of the APA formatting style. </li>
                  <li>The list of sources is alphabetized.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step5">&larr;&nbsp;PREVIOUS</button>
                  <Button onClick={(e) => this.onComplete(e)} className={styles.btn_finish} light>Finish</Button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* page-4 */}
        <div className={classnames(styles.perfect_essay)}>
          <div className={styles.catchword_left}>THE RELATIONSHIP BETWEEN LEADER BEHAVIOR AND EMPLOYEE'S <br /> PERFORMANCE</div>
          <div className={styles.catchword}>3</div>
        </div>


      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  nextStage: () => dispatch(profileUpdateStages()),
});

export default connect(null, mapDispatchToProps)(EssayResearchArgumentative);




// WEBPACK FOOTER //
// ./src/components/PerfectEssay/EssayResearchArgumentative.js